import { ArdoqId } from '@ardoq/api-types';
import type { MetaInfo } from 'streams/views/mainContent/types';
import { isDiscontinuedView } from 'viewDeprecation/discontinuedSlides';
import { Slide } from './types';

type SelectableSlide = Pick<Slide, 'id' | 'viewId'>;

type SlideSelectionArgs = {
  slides: SelectableSlide[];
  selectedSlideId: ArdoqId | null;
  deprecatedViews: MetaInfo[];
};

export const getNextSelectableSlideId = ({
  slides,
  selectedSlideId,
  deprecatedViews,
}: SlideSelectionArgs): ArdoqId | undefined => {
  const nextSlideIndex = selectedSlideId
    ? slides.findIndex(({ id }) => id === selectedSlideId) + 1
    : 0;

  if (nextSlideIndex >= slides.length) return undefined;

  return slides
    .slice(nextSlideIndex)
    .find(({ viewId }) => !isDiscontinuedView(deprecatedViews, viewId))?.id;
};

type SlideToPlayFromArgs = {
  allSlideIds: ArdoqId[];
  selectedSlideId: ArdoqId | null;
  isSelectedSlideDiscontinued: boolean;
};

export const getSlideToPlayFrom = ({
  allSlideIds,
  selectedSlideId,
  isSelectedSlideDiscontinued,
}: SlideToPlayFromArgs): ArdoqId | null => {
  if (!selectedSlideId) return null;
  if (!allSlideIds.includes(selectedSlideId)) return null;
  if (isSelectedSlideDiscontinued) return null;
  return selectedSlideId;
};

export const getPreviousSelectableSlideId = ({
  slides,
  selectedSlideId,
  deprecatedViews,
}: SlideSelectionArgs): ArdoqId | undefined => {
  const prevSlideIndex = selectedSlideId
    ? slides.findIndex(({ id }) => id === selectedSlideId) - 1
    : 0;

  if (prevSlideIndex < 0) return undefined;

  return slides
    .slice(0, prevSlideIndex + 1)
    .findLast(({ viewId }) => !isDiscontinuedView(deprecatedViews, viewId))?.id;
};
